import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-customer",
  "use": "icon-customer-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 80 80\" id=\"icon-customer\">\n<g>\n\t<circle cx=\"40.229\" cy=\"25.722\" r=\"16.5\" />\n\t<path d=\"M67.233,59.392v6.83c0,2.76-2.24,5-5,5h-44c-2.77,0-5-2.24-5-5v-6.83c0-8.38,6.79-15.17,15.16-15.17\n\t\th4.11l7.73,20.83l7.72-20.83h4.11C60.443,44.222,67.233,51.012,67.233,59.392z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol